export default "__VITE_ASSET__Den07OUY__"